import store from "../store/mainStore.js";

const translate = ({ key }) => {
  let newWord;
  const odabraniJezik = store.getState().systemState.lang;
  const dopusteniJezici = store.getState().dictionaryState.languages;
  const dictionary = store.getState().dictionaryState.translations;
  const dictionaryZaJezik = dictionary[odabraniJezik];

  if (key === "---") {
    return "---";
  }

  if (key === " ") {
    return "noText";
  }

  if (!key) {
    return null;
  }

  if (!odabraniJezik) {
    return null;
  }

  if (!dictionaryZaJezik) {
    return null;
  }

 

  try {
    newWord = dictionaryZaJezik.translations[key];

    if (!newWord) {
      throw new Error(`Ne postoji value za ${key}`);
    }

    if (!dopusteniJezici.includes(odabraniJezik)) {
      throw new Error(
        `Odabrani je jezik ${odabraniJezik} koji nije u listi dopuštenih jezika`
      );
    }
  } catch (err) {
    console.log(err);
    newWord = `Greška u prijevodu`;
  }

  return newWord;
};

export default translate;
